import { DocumentationPage } from './_article.jsx';
export default function PublishingEpisodesPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}